import { NavigationData, PatientTabs } from 'src/features/tabsState/constants';

export const getTabByPath = (path) => {
  if (!path) return null;

  const segments = path.split('/');
  const lastSegment = segments[segments.length - 1];

  return Object.values(PatientTabs).find(
    (tabConfig) => tabConfig.routes.includes(lastSegment) || tabConfig.text === 'Note',
  );
};

export const hasTabPermissions = (tab, permissions) => {
  const sectionPermissions = permissions?.patientChart?.sections;

  if (!tab || !sectionPermissions) {
    return false;
  }

  // Special case for Note tab - check if user can add documentation
  if (tab.text === 'Note') {
    return !!permissions?.patientChart?.actions?.canAddDocumentation;
  }

  // Check if user has permissions for any of the tab's routes
  return Object.values(NavigationData)
    .filter((item) => item.mainTab === tab.text)
    .some((item) =>
      item.permissionFields.some((permissionField) => Boolean(sectionPermissions[permissionField])),
    );
};

export const getTabByText = (text) => Object.values(PatientTabs).find((tab) => tab.text === text);

export const getTabPath = (tab, patientId, docId) => {
  switch (tab) {
    case PatientTabs.Note:
      return `/dashboard-client/patients/details/${patientId}/note/${docId}/edit`;
    default:
      return `/dashboard-client/patients/details/${patientId}/${tab.routes[0]}`;
  }
};
